import { BaseService } from '@estee/elc-service';
import { ServiceInitializer } from '@estee/elc-universal-utils';

const { name, version } = __serviceInfo__;

export class SmartgiftService extends BaseService {
    constructor(serviceInitializer: ServiceInitializer) {
        super(name, version, serviceInitializer);
    }
}

export default {
    smartgiftService: 'SMARTGIFT_SERVICE',
    configStore: 'CONFIG_STORE',
    smartGiftViewController: 'SMARTGIFT_VIEW_CONTROLLER'
};
